import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Table from 'src/components/VehicleTrackingDetails/Tables/Table';

import { useMediaQuery } from '@mui/system';

function PurchaseOrderLineItemTable({ selectedPoIds }) {
  const isMobile = useMediaQuery('(max-width: 600px)');

  // Get PO items data from the reducer
  const vehicleTrackingDataReducer = useSelector(
    (state) => state?.VehicleTrackingReducer,
  );

  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer.userData.tenant?.theme;
  const [selectedPoItems, setSelectedPOItems] = useState([]);

  // Get selected PO IDs if they exist in the reducer
  const { poItems } = vehicleTrackingDataReducer;
  useEffect(() => {
    setSelectedPOItems(
      poItems?.filter((item) => selectedPoIds?.includes(item?.po_number)),
    );
  }, [poItems, selectedPoIds]);

  const anyShowItemPrice = poItems?.some((item) => item.show_item_price);
  let headers = [
    {
      label: 'PO Number',
      value: 'po_number',
    },
    {
      label: 'Material Code',
      value: 'material_code',
    },
    {
      label: 'Material Description',
      value: 'material_description',
    },
    {
      label: 'Rate',
      value: 'rate',
    },
    {
      label: 'PO Quantity',
      value: 'po_quantity',
    },
    {
      label: 'Open Quantity',
      value: 'open_quantity',
    },
    {
      label: 'Blocked Quantity',
      value: 'blocked_quantity',
    },
    {
      label: 'Unit Of Measurement',
      value: 'unit_of_measurement',
    },
    { label: 'Plant', value: 'plant' },
  ];
  headers = headers?.filter(
    (header) => header.value !== 'rate' || anyShowItemPrice,
  );

  const renderTableContent = () => (
    <tbody>
      {selectedPoItems?.length > 0 ? (
        selectedPoItems
          .filter((i) => i.open_quantity > 0)
          .map((item) => (
            <tr key={`${item?.po_number}-${item?.material_code}`}>
              {headers.map((header) => (
                <td className="" key={header.value}>
                  <div className="div-flex-row">
                    <span className="text-sm">
                      {[
                        'po_quantity',
                        'blocked_quantity',
                        'open_quantity',
                      ].includes(header.value)
                        ? item[header.value] ?? 0
                          ? `${item[header.value]} ${item?.unit_of_measurement}`
                          : `0 ${item?.unit_of_measurement}`
                        : item[header.value]}
                    </span>
                  </div>
                </td>
              ))}
            </tr>
          ))
      ) : (
        <tr>
          <td
            colSpan={headers?.length || 1}
            className="no-data-found-message border-bottom"
          >
            <span className="text-sm">No PO Items Found</span>
          </td>
        </tr>
      )}
    </tbody>
  );

  return (
    <>
      <div className="div-flex-row div-space-between section-title div-align-center">
        <div className="text-md text-semi-bold">PO Data</div>

        <span className={`${isMobile ? 'text-xs' : 'text-sm'} text-semi-bold`}>
          {poItems?.length} Items
        </span>
      </div>
      <div
        className={`table-fixed-container theme-scrollable-container-${themeColor} theme-horizontal-scrollable-container-${themeColor}`}
      >
        <Table
          headers={headers}
          minCellWidth={100}
          tableContent={renderTableContent()}
        />
      </div>
    </>
  );
}

export default PurchaseOrderLineItemTable;
